import { ExpandMoreOutlined } from '@mui/icons-material';
import {
  AccordionSummary,
  Box,
  ListSubheader,
  AccordionDetails,
} from '@mui/material';

import { useState } from 'react';

import { tss } from 'tss-react/mui';

import { Or2Accordion } from '@/components/Surface/Or2Accordion';

import type { DocumentType } from '@/gql';

import { MultiGroupPinnedPostCollection } from '@/modules/post/MultiGroupPinnedPostCollection';

import type { MULTI_GROUPS_POST_FRAGMENT } from './MultiGroupPostCollection';

interface Props {
  posts: Array<DocumentType<typeof MULTI_GROUPS_POST_FRAGMENT>>;
  loading: boolean;
}

const useStyles = tss.create(({ theme }) => {
  return {
    accordion: {
      marginTop: theme.spacing(2),
      backgroundColor: 'transparent',
      '&:hover': {
        backgroundColor: theme.background,
      },
    },
  };
});

export const MultiGroupPinnedPostsAccordion = ({ posts, loading }: Props) => {
  const { classes } = useStyles();
  const [expanded, setExpanded] = useState(false);

  return (
    <>
      {posts.length > 0 && (
        <Or2Accordion
          onTop
          expanded={expanded}
          onChange={(e, ex) => {
            setExpanded(ex);
          }}
          slotProps={{
            transition: {
              unmountOnExit: true,
            },
          }}
          disabled={loading}
          className={classes.accordion}
        >
          <AccordionSummary expandIcon={<ExpandMoreOutlined />}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <ListSubheader sx={{ p: 0, backgroundColor: 'transparent' }}>
                {`Pinned posts (${posts.length})`}
              </ListSubheader>
            </Box>
          </AccordionSummary>
          <AccordionDetails>
            <MultiGroupPinnedPostCollection posts={posts} loading={loading} />
          </AccordionDetails>
        </Or2Accordion>
      )}
    </>
  );
};
